var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3562 53.2125C42.9794 53.2125 53.2125 42.9794 53.2125 30.3562C53.2125 17.7331 42.9794 7.5 30.3562 7.5C17.7331 7.5 7.5 17.7331 7.5 30.3562C7.5 42.9794 17.7331 53.2125 30.3562 53.2125Z",
    fill: "url(#paint0_radial_4760_27506)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.8562 53.2125C43.4794 53.2125 53.7125 42.9794 53.7125 30.3562C53.7125 17.7331 43.4794 7.5 30.8562 7.5C18.2331 7.5 8 17.7331 8 30.3562C8 42.9794 18.2331 53.2125 30.8562 53.2125Z",
    fill: "url(#paint1_radial_4760_27506)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7922 34.2262C45.6221 34.1624 45.4307 34.1518 45.2606 34.2049C40.4343 35.5869 35.4272 36.2779 30.3669 36.2779C25.3067 36.2779 20.2889 35.5763 15.4731 34.2049C15.2924 34.1518 15.1117 34.1624 14.9416 34.2262C14.4207 34.4388 13.5915 35.2255 14.6864 38.234V38.2446C16.3023 42.093 20.5865 48.8542 30.3563 48.8542C40.1047 48.8542 44.3889 42.0823 46.0474 38.2446C47.1317 35.2255 46.3131 34.4388 45.7922 34.2262Z",
    fill: "url(#paint2_linear_4760_27506)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3181 19.5768C24.0736 18.6944 22.9679 18.4074 21.3202 18.8645C19.9275 19.2579 17.0785 20.8738 15.7283 24.18C15.4838 24.7859 16.1536 24.8922 16.4406 24.467C17.4292 23 20.5016 20.6186 23.2975 20.1509C24.435 19.9595 24.3181 19.5768 24.3181 19.5768Z",
    fill: "url(#paint3_linear_4760_27506)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1691 26.6783C22.5851 25.7003 20.5441 25.8066 19.0557 26.9229C18.3009 27.497 17.5568 28.3687 17.1209 29.7294C17.0465 29.9527 16.9934 30.1972 16.9827 30.4417C16.9508 30.9307 17.291 31.3666 17.8438 30.8563C22.0643 26.8697 25.0196 30.9732 25.0196 30.9732C25.5937 31.3878 26.1784 30.5267 26.0615 29.7294C26.0296 29.4956 25.9976 29.2511 25.9445 29.0384C25.6043 27.869 24.9133 27.1355 24.1691 26.6783Z",
    fill: "url(#paint4_radial_4760_27506)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4838 34.1621C45.4519 34.1621 45.42 34.1621 45.3775 34.1728C40.5086 35.576 35.459 36.2883 30.3455 36.2883C25.2321 36.2883 20.1824 35.576 15.3136 34.1728C15.2816 34.1621 15.2498 34.1621 15.2072 34.1621C14.8777 34.1941 13.3043 34.5236 14.6544 38.2444V38.255C15.3136 39.8071 16.4085 41.8376 18.1201 43.698C16.5149 41.7951 18.4922 40.7426 22.0109 41.1679C25.5298 41.5931 30.3455 41.6037 30.3455 41.6037C30.3455 41.6037 35.1506 41.5931 38.6801 41.1679C42.1989 40.7426 44.1762 41.7951 42.571 43.698C44.2826 41.8376 45.3775 39.8071 46.0366 38.255V38.2444C47.3867 34.513 45.8134 34.1834 45.4838 34.1621Z",
    fill: "url(#paint5_linear_4760_27506)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.773 39.3924C44.1125 39.1053 45.1225 37.9891 45.25 36.6177L45.3775 35.2783C40.5086 36.6496 35.459 37.3513 30.3562 37.3513C25.2535 37.3513 20.2038 36.6496 15.3349 35.2783L15.4624 36.6177C15.59 37.9785 16.6 39.0948 17.9395 39.3924C22.0004 40.2747 26.1677 40.7106 30.3562 40.7106C34.5448 40.7106 38.7121 40.2642 42.773 39.3924Z",
    fill: "url(#paint6_radial_4760_27506)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9338 29.0278C25.7849 28.5494 25.5829 28.1348 25.3597 27.7946C25.0195 27.3056 24.6049 26.9442 24.169 26.6784C22.585 25.7004 20.5439 25.8066 19.0556 26.9229C18.3008 27.497 17.5567 28.3687 17.1208 29.7294C17.0783 29.857 17.0464 29.9952 17.0251 30.1334V30.144C18.8855 27.2418 21.5645 27.0399 21.5645 27.0399C21.5645 27.0399 24.2222 26.8166 26.0188 29.4105C25.9975 29.283 25.9657 29.1554 25.9338 29.0278Z",
    fill: "url(#paint7_linear_4760_27506)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3945 19.5768C36.639 18.6944 37.7447 18.4074 39.3924 18.8645C40.7851 19.2579 43.6341 20.8738 44.9842 24.18C45.2288 24.7859 44.559 24.8922 44.272 24.467C43.2833 23 40.211 20.6186 37.4151 20.1509C36.2776 19.9595 36.3945 19.5768 36.3945 19.5768Z",
    fill: "url(#paint8_linear_4760_27506)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5434 26.6783C38.1274 25.7003 40.1685 25.8066 41.6568 26.9229C42.4116 27.497 43.1558 28.3687 43.5917 29.7294C43.6661 29.9527 43.7192 30.1972 43.7298 30.4417C43.7617 30.9307 43.4216 31.3666 42.8687 30.8563C38.6483 26.8697 35.693 30.9732 35.693 30.9732C35.1189 31.3878 34.5342 30.5267 34.6511 29.7294C34.683 29.4956 34.7149 29.2511 34.7681 29.0384C35.1083 27.869 35.7992 27.1355 36.5434 26.6783Z",
    fill: "url(#paint9_radial_4760_27506)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7786 29.0278C34.9274 28.5494 35.1294 28.1348 35.3527 27.7946C35.6929 27.3056 36.1075 26.9442 36.5433 26.6784C38.1273 25.7004 40.1684 25.8066 41.6567 26.9229C42.4115 27.497 43.1557 28.3687 43.5915 29.7294C43.634 29.857 43.666 29.9952 43.6872 30.1334V30.144C41.8268 27.2418 39.1478 27.0399 39.1478 27.0399C39.1478 27.0399 36.4901 26.8166 34.6936 29.4105C34.7148 29.283 34.7467 29.1554 34.7786 29.0278Z",
    fill: "url(#paint10_linear_4760_27506)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.379 41.0512C43.5385 40.8173 43.2833 40.5197 43.0282 40.6366C41.3911 41.3489 37.5002 42.582 30.3562 42.582C22.9785 42.582 19.2683 41.3914 17.695 40.6685C17.4398 40.5516 17.1847 40.8492 17.3441 41.0831C19.5872 44.3892 23.5632 47.8549 30.3562 47.8549C37.1494 47.8443 41.1253 44.368 43.379 41.0512Z",
    fill: "url(#paint11_radial_4760_27506)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4760_27506",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8592 21.0934) scale(27.5731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB82E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4760_27506",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3592 21.0934) scale(21.693)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4760_27506",
    x1: 14.1315,
    y1: 41.5123,
    x2: 46.5811,
    y2: 41.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4760_27506",
    x1: 20.0842,
    y1: 22.3477,
    x2: 19.4346,
    y2: 20.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4760_27506",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5445 28.6941) rotate(175.474) scale(3.5262 2.50037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4760_27506",
    x1: 46.3993,
    y1: 38.9237,
    x2: 14.5081,
    y2: 38.9237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4760_27506",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3562 37.9994) scale(27.6125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8BBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4760_27506",
    x1: 21.9153,
    y1: 24.2543,
    x2: 21.6354,
    y2: 28.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4760_27506",
    x1: 40.6497,
    y1: 22.3514,
    x2: 41.2992,
    y2: 20.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4760_27506",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1427 28.6937) rotate(4.5256) scale(3.52619 2.50037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4760_27506",
    x1: 38.7776,
    y1: 24.2554,
    x2: 39.0575,
    y2: 28.0934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_4760_27506",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3612 44.2273) scale(27.2074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8BBBD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappy);
export default __webpack_public_path__ + "static/media/icon_happy.ad0c1d59513146c1994d4acd68c37b81.svg";
export { ForwardRef as ReactComponent };